import React from "react";

const features = [
  {
    icon: "🩺",
    title: "Vet Certified Health",
    desc: "Every pet undergoes a thorough health check and is up to date on vaccinations.",
  },
  {
    icon: "🏡",
    title: "Raised With Love",
    desc: "All our pets are raised in warm, nurturing environments — not factory farms.",
  },
  {
    icon: "📋",
    title: "Detailed Profiles",
    desc: "Full info on age, temperament, and care requirements before you commit.",
  },
];

const About = () => {
  return (
    <section id="about" className="bg-slate-50 py-24 mt-10">
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-16">
        {/* Image */}
        <div className="w-full lg:w-1/2 flex-shrink-0">
          <div className="relative rounded-3xl overflow-hidden shadow-xl">
            <img
              className="w-full h-80 lg:h-[420px] object-cover"
              src="https://cdn.pixabay.com/photo/2021/11/22/04/28/animal-6815808_1280.jpg"
              alt="Happy pets at PetHouse"
            />
            {/* Stat badge overlay */}
            <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-sm rounded-2xl px-5 py-3 shadow-lg">
              <p className="text-2xl font-bold text-slate-900">500+</p>
              <p className="text-xs text-slate-500">Happy families served</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="w-full lg:w-1/2">
          <p className="text-amber-500 font-semibold text-sm uppercase tracking-widest mb-3">
            About PetHouse
          </p>
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-5">
            Trusted Pet Seller <br className="hidden lg:block" />
            Since Day One
          </h2>
          <p className="text-slate-500 leading-relaxed mb-8">
            At PetHouse, we provide a hassle-free experience for purchasing
            healthy, well-socialized pets. Specializing in dogs, cats, and small
            animals — all raised in loving environments — our pets are ready for
            their forever homes.
          </p>

          <div className="space-y-5">
            {features.map((f) => (
              <div key={f.title} className="flex items-start gap-4">
                <span className="text-2xl mt-0.5">{f.icon}</span>
                <div>
                  <h4 className="font-semibold text-slate-900 text-sm">
                    {f.title}
                  </h4>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
